import React from "react";

interface Props {
  status?: string;
  size?: string;
}

const StatusBadge: React.FC<Props> = ({ status = "New", size = "sm" }) => {
  const statusClassMap: Record<string, string> = {
    New: "bg-teal-50 text-teal-700 ring-teal-600/20",
    Contacted: "bg-blue-50 text-blue-700 ring-blue-600/20",
    Engaging: "bg-orange-50 text-orange-800 ring-orange-600/20",
    Potential: "bg-green-50 text-green-700 ring-green-600/10",
    Enrolled: "bg-yellow-50 text-yellow-700 ring-yellow-600/20",
    Cold: "bg-gray-50 text-gray-700 ring-gray-600/20",
    Lost: "bg-red-50 text-red-700 ring-red-600/10",
    Unassigned: "bg-gray-50 text-gray-700 ring-gray-600/20",
    Duplicate: "bg-purple-50 text-purple-700 ring-purple-600/20",
    Pending: "bg-blue-50 text-blue-700 ring-blue-600/20",
    Reviewed: "bg-orange-50 text-orange-800 ring-orange-600/20",
    Accepted: "bg-green-50 text-green-700 ring-green-600/10",
    Rejected: "bg-red-50 text-red-700 ring-red-600/10",
  };

  const sizeClassMap: Record<string, string> = {
    sm: "text-xs px-2 py-1",
    lg: "text-lg px-4 py-2",
  };

  const badgeClass =
    statusClassMap[status] || "bg-gray-100 text-gray-600 ring-gray-300";
  const sizeClass = sizeClassMap[size] || sizeClassMap.sm;

  return (
    <span
      className={`inline-flex items-center rounded-md px-2 py-1 font-medium ring-1 ring-inset ${badgeClass} ${sizeClass}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
